import { ArrowDownIcon, ArrowUpIcon } from '@protector/icons';
import { useState } from 'react';
import { Else, If, Then, Unless } from 'react-if';

import { Collapsable, CollapsibleSectionContainer } from './details-collapsible-section.styles';

interface Props {
  children: React.ReactNode;
  dataTestId?: string;
}

const DetailsCollapsibleSection = ({ children, dataTestId }: Props) => {
  const [isCollapsed, setIsCollapsed] = useState<boolean>(false);

  const doCollapse = () => setIsCollapsed(prev => !prev);

  return (
    <CollapsibleSectionContainer isCollapsed={isCollapsed} data-testid={dataTestId}>
      <Unless condition={isCollapsed}>{children}</Unless>

      <Collapsable onClick={doCollapse}>
        <If condition={isCollapsed}>
          <Then>
            <ArrowDownIcon />
          </Then>
          <Else>
            <ArrowUpIcon />
          </Else>
        </If>
      </Collapsable>
    </CollapsibleSectionContainer>
  );
};

export default DetailsCollapsibleSection;
